export default "__VITE_ASSET__DNEg4aw9__"